import { useMutation } from '@tanstack/vue-query'

export const useSendActiveCampaignTag = () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async (tagId: number) =>
      await $fetch<string>(`/api/user/${authStore.getUser!.id}/tag`, {
        method: 'POST',
        body: JSON.stringify({ tagId }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
  })
}
